function splitLongToken(token: string, maximumLength: number): string[] {
  const parts: string[] = [];
  for (let offset = 0; offset < token.length; offset += maximumLength) {
    parts.push(token.slice(offset, offset + maximumLength));
  }
  return parts;
}

function packWords(words: readonly string[], maximumLength: number): string[] {
  const chunks: string[] = [];
  let current = "";

  for (const word of words) {
    if (word.length > maximumLength) {
      if (current !== "") chunks.push(current);
      chunks.push(...splitLongToken(word, maximumLength));
      current = "";
    } else if (current === "") {
      current = word;
    } else if (`${current} ${word}`.length <= maximumLength) {
      current = `${current} ${word}`;
    } else {
      chunks.push(current);
      current = word;
    }
  }

  if (current !== "") chunks.push(current);
  return chunks;
}

export function splitIntoChunks(
  text: string,
  maximumLength = 200,
): readonly string[] {
  if (!Number.isInteger(maximumLength) || maximumLength < 1) {
    throw new RangeError("maximumLength must be a positive integer");
  }

  const trimmed = text.trim();
  if (trimmed === "") return [];

  const clauses = trimmed.split(/(?<=[.!?;:])\s+/);
  const chunks: string[] = [];

  for (const clause of clauses) {
    if (clause.length <= maximumLength) {
      chunks.push(clause);
    } else {
      chunks.push(...packWords(clause.split(/\s+/), maximumLength));
    }
  }

  return chunks;
}
